// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2342":"22c1d713","2725":"54e1f925"}[chunkId] + ".css";
};